import ForgotPassword from "./ForgotPassword";
import LoginMethod from "./LoginMethod";
import TeamSelect from "./TeamSelect";
import SingleTeam from "./SingleTeam";


export default [
    ForgotPassword,
    LoginMethod,
    TeamSelect,
    SingleTeam,
];
